













































































































import WindowFrame from "../WindowFrame.vue";
import WindowMixin from "../WindowMixin.vue";
import Divider from "../parts/Divider.vue";
import CtrlButton from "@/components/parts/CtrlButton.vue";

import { Action, Getter, Mutation } from "vuex-class";
import { Component, Mixins } from "vue-mixin-decorator";

@Component({
  components: {
    CtrlButton,
    WindowFrame,
    Divider
  }
})
export default class CustomDiceBotTableWindow extends Mixins<WindowMixin>(
  WindowMixin
) {
  @Action("windowClose") private windowClose: any;
  @Action("windowOpen") private windowOpen: any;
  @Action("setProperty") private setProperty: any;
  @Action("addListObj") private addListObj: any;
  @Action("deleteListObj") private deleteListObj: any;
  @Getter("loadYaml") private loadYaml: any;
  @Getter("getViewName") private getViewName: any;
  @Getter("getObj") private getObj: any;
  @Getter("playerKey") private playerKey: any;
  @Getter("chatActorKey") private chatActorKey: any;
  @Getter("customDiceBotList") private customDiceBotList: any;
  @Getter("customDiceBotRoomSysList") private customDiceBotRoomSysList: any;
  @Getter("diceSystemList") private diceSystemList: any;

  private open() {
    const button: CtrlButton = this.$refs.button as CtrlButton;
    button.requestFocus();
  }

  private addButtonOnClick(): void {
    this.loadYaml("/static/conf/system/default/customDiceBot.yaml")
      .then((customDiceBot: any) => {
        // 読み込めた場合
        const tableContents: any = customDiceBot!.tableContents;
        const tableContentsArr = [];
        for (const prop in tableContents) {
          if (!tableContents.hasOwnProperty(prop)) continue;
          tableContentsArr.push(`${prop}:${tableContents[prop]}`);
        }
        customDiceBot.tableContents = tableContentsArr.join("\n");

        this.addListObj({
          propName: "customDiceBot",
          kind: "customDiceBot",
          commandName: customDiceBot.commandName,
          diceRoll: customDiceBot.diceRoll,
          tableTitle: customDiceBot.tableTitle,
          diceBotSystem: "DiceBot",
          tableContents: tableContentsArr.join("\n")
        }).then(() => {
          const lastKey: string = this.customDiceBotList[
            this.customDiceBotList.length - 1
          ].key;
          this.setProperty({
            property: "private.display.editCustomDiceBotTableWindow.objKey",
            value: lastKey,
            logOff: true
          }).then(() => {
            this.windowOpen("private.display.editCustomDiceBotTableWindow");
          });
        });
      })
      .catch((err: any) => {
        window.console.log(err);

        this.addListObj({
          propName: "customDiceBot",
          kind: "customDiceBot",
          commandName: "PGT",
          diceRoll: "1d6",
          tableTitle: "ペンギン属表(Penguin's Generic name Table)",
          diceBotSystem: "DiceBot",
          tableContents: [
            "1:コウテイペンギン属（学名：Aptenodytes）。学名の意味：「翼のない潜水者」。コウテイペンギン／キングペンギン",
            "2:アデリーペンギン属（学名：Aygoscelis）。学名の意味：「尻についた肢（あし）」。アデリーペンギン／ジェンツーペンギン／ヒゲペンギン",
            "3:フンボルトペンギン属（学名：Spheniscus）。学名の意味：「楔のような」。ガラパゴスペンギン／ケープペンギン／フンボルトペンギン／マゼランペンギン",
            "4:マカロニペンギン属（学名：Eudyptes）。学名の意味：「優れた潜水者」。フィヨルドランドペンギン／シュレーターペンギン／スネアーズペンギン／マカロニペンギン／ロイヤルペンギン／イワトビペンギン",
            "5:キンメペンギン属（学名：Megadyptes）。学名の意味：「大型の潜水者」。キンメペンギン（一種一属の固有種）",
            "6:コガタペンギン属（学名：Eudyptula）。学名の意味：「非常に小さい」「優れた潜水者」。コガタペンギン／ハネジロペンギン"
          ].join("\n")
        }).then(() => {
          const lastKey: string = this.customDiceBotList[
            this.customDiceBotList.length - 1
          ].key;
          this.setProperty({
            property: "private.display.editCustomDiceBotTableWindow.objKey",
            value: lastKey,
            logOff: true
          }).then(() => {
            this.windowOpen("private.display.editCustomDiceBotTableWindow");
          });
        });
      });
  }

  private copyButtonOnClick(): void {
    if (!this.selectLineKey) {
      alert("コピー対象を選択してください。");
      return;
    }

    const kind = this.selectLineKey.split("-")[0];

    const useList =
      kind === "customDiceBotRoomSys"
        ? this.customDiceBotRoomSysList
        : this.customDiceBotList;
    const customDiceBotObj: any = JSON.parse(
      JSON.stringify(
        useList.filter((bot: any) => bot.key === this.selectLineKey)[0]
      )
    );

    customDiceBotObj.propName = "customDiceBot";
    customDiceBotObj.kind = "customDiceBot";
    this.addListObj(customDiceBotObj);
  }

  private changeButtonOnClick(key: string): void {
    if (!this.selectLineKey) {
      alert("変更対象を選択してください。");
      return;
    }

    this.setProperty({
      property: "private.display.editCustomDiceBotTableWindow.objKey",
      value: this.selectLineKey,
      logOff: true
    });
    this.windowOpen("private.display.editCustomDiceBotTableWindow");
  }

  private deleteButtonOnClick(): void {
    if (!this.selectLineKey) {
      alert("削除対象を選択してください。");
      return;
    }

    this.deleteListObj({ key: this.selectLineKey, propName: "customDiceBot" });
    this.selectLine("");
  }

  private cancelButtonOnClick(): void {
    this.windowClose("private.display.customDiceBotTableWindow");
  }

  private moveDev(event: any) {
    if (this.movingIndex > -1) {
      const diff = event.clientX - this.startX;
      const afterLeftWidth = this.startLeftWidth + diff;
      const afterRightWidth = this.startRightWidth - diff;
      if (afterLeftWidth >= 10 && afterRightWidth >= 10) {
        const paramObj: any = {};
        paramObj[this.movingIndex] = afterLeftWidth;
        paramObj[this.movingIndex + 1] = afterRightWidth;
        this.setProperty({
          property: "private.display.customDiceBotTableWindow.widthList",
          value: paramObj,
          logOff: true
        });
      }
    }
  }

  private moveDevEnd() {
    this.setProperty({
      property: "private.display.customDiceBotTableWindow",
      value: {
        hoverDevIndex: -1,
        movingIndex: -1,
        startX: -1,
        startLeftWidth: -1,
        startRightWidth: -1
      },
      logOff: true
    });
  }

  private selectLine(selectLineKey: string) {
    this.setProperty({
      property: "private.display.customDiceBotTableWindow.selectLineKey",
      value: selectLineKey,
      logOff: true
    });
  }

  private getSystemName(systemKey: string) {
    if (systemKey === "DiceBot") return "指定なし";
    const systemObj: any = this.diceSystemList.filter(
      (systemObj: any) => systemObj.system === systemKey
    )[0];
    return systemObj.name;
  }

  private get listLengthIsOdd(): boolean {
    return (
      (this.customDiceBotList.length + this.customDiceBotRoomSysList.length) %
        2 !==
      0
    );
  }

  /* Start 列幅可変テーブルのプロパティ */
  private get selectLineKey() {
    return this.$store.state.private.display.customDiceBotTableWindow
      .selectLineKey;
  }

  private get widthList() {
    return this.$store.state.private.display.customDiceBotTableWindow.widthList;
  }

  private get movingIndex() {
    return this.$store.state.private.display.customDiceBotTableWindow
      .movingIndex;
  }

  private get startX() {
    return this.$store.state.private.display.customDiceBotTableWindow.startX;
  }

  private get startLeftWidth() {
    return this.$store.state.private.display.customDiceBotTableWindow
      .startLeftWidth;
  }

  private get startRightWidth() {
    return this.$store.state.private.display.customDiceBotTableWindow
      .startRightWidth;
  }

  private get colStyle() {
    return (index: number) => ({ width: `${this.widthList[index]}px` });
  }
  /* End 列幅可変テーブルのプロパティ */
}
